export const actionColumnFilterOptions = [
    { text: "Enabled", value: true },
    { text: "Disabled", value: false },
];
